export const ERR_DATA = 255
export const MAX_POINTS = 29
export const ERR_DATA_REPLACE = 40



// WEBPACK FOOTER //
// ./src/views/home/charts/config.js